import styled, { keyframes } from 'styled-components';

export const ContentWrapper = styled.div`
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
  flex: 1;
  min-height: 0;
  padding: 20px 24px;
  background: ${({ theme }) => theme.colors.background.dark};
`;

export const ContentInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 850px;
  margin: 0 auto;
`;

export const DateRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin: 8px 0;
`;

export const DateDivider = styled.span`
  opacity: 0.6;
  flex: 1;
  height: 1px;
  background: ${({ theme }) => theme.colors.background.extraLight};
`;

export const DateBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 11px;
  letter-spacing: 0.2px;
`;

export const MessageGroup = styled.div<{ $isUser?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $isUser }) => ($isUser ? 'flex-end' : 'flex-start')};
  gap: ${({ $isUser }) => ($isUser ? '6px' : '12px')};
`;

export const MessageRow = styled.div<{ $isUser?: boolean }>`
  display: flex;
  justify-content: ${({ $isUser }) => ($isUser ? 'flex-end' : 'flex-start')};
`;

export const MessageBubble = styled.div<{ $isUser?: boolean }>`
  overflow-wrap: anywhere;
  max-width: 90%;
  border: ${({ $isUser }) => ($isUser ? '1px solid #29436C' : 'none')};
  border-radius: 12px;
  padding: ${({ $isUser }) => ($isUser ? '10px 14px' : '0')};
  background: ${({ $isUser, theme }) => ($isUser ? theme.colors.background.light : 'none')};
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 13px;
  line-height: 1.4;
  word-break: break-word;
  white-space: pre-wrap;
`;

export const MessageMeta = styled.span<{ $isUser?: boolean }>`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 11px;
  text-align: ${({ $isUser }) => ($isUser ? 'right' : 'left')};
  letter-spacing: 0.2px;
`;

export const MessageMetaRow = styled.div<{ $isUser?: boolean }>`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
`;

export const BotMetaDivider = styled.span`
  opacity: 0.6;
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.colors.background.extraLight};
`;

const pulse = keyframes`
  0% {
    opacity: 0.2;
    transform: translateY(0);
  }
  20% {
    opacity: 1;
    transform: translateY(-2px);
  }
  100% {
    opacity: 0.2;
    transform: translateY(0);
  }
`;

export const LoaderWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 6px;
`;

export const LoaderDot = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.border};
  animation: ${pulse} 1.2s infinite ease-in-out;

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }
`;
